import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { SERVER, LOGON_INFO } from "../app.constants";
import { MessageService } from "../common/message.service";


@Injectable()
export class NoticeService {

    constructor(
        private _htc: HttpClient,
        private msgService: MessageService
    ) { }


    getNoticeCount(): Observable<any> {
        return this._htc.get(SERVER.baseURL+'/notice-count/'+LOGON_INFO.COMP_ID+'/');
    }


    getNoticeList(page: number, isAll: boolean): Observable<Notice[]> {
        let params = new HttpParams().set('page', page.toString()).append('all', isAll.toString());
        return this._htc.get<Notice[]>(SERVER.baseURL+'/notice-list/'+LOGON_INFO.PARENT_COMP_ID+'/', {params: params});
    }


    fetchNotice() {
        //表示期間中であるお知らせリストを取得する
        this.getNoticeList(1, false)
        .take(1).subscribe(
            data => {
                this.msgService.addNotice(data['results']);
            }
        );
    }


    registNotice(notice: Notice): Observable<Notice> {
        this.setParam(notice);
        return this._htc.post<Notice>(SERVER.baseURL+'/notice-regist/', JSON.stringify(notice));
    }


    updateNotice(notice: Notice): Observable<Notice> {
        this.setParam(notice);
        return this._htc.put<Notice>(SERVER.baseURL+'/notice-update/'+notice.id+'/', JSON.stringify(notice));
    }


    deleteNotice(id: number): Observable<any> {
        return this._htc.delete(SERVER.baseURL+'/notice-delete/'+id+'/');
    }


    private setParam(notice: Notice) {
        notice.comp_id = LOGON_INFO.COMP_ID;
        notice.create_id = LOGON_INFO.USER_ID;
        notice.update_id = LOGON_INFO.USER_ID;
        notice.display_start = notice.display_start.formatted.split('/').join('-');
        notice.display_end = notice.display_end.formatted.split('/').join('-');
    }

}



export class Notice {
    id: number;
    comp_id: string;
    title: string;
    content: string;
    display_start: any;
    display_end: any;
    is_past_flag: string;
    is_active: boolean;
    create_id: string;
    create_name: string;
    create_date: Date;
    update_id: string;
    update_name: string;
    update_date: Date;
}



// WEBPACK FOOTER //
// ./src/app/notice/notice.service.ts